/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Comment } from './comment';
import { User } from './user';

export interface Task { 
    id?: string;
    state?: Task.StateEnum;
    priority?: Task.PriorityEnum;
    title?: string;
    dueDate?: Date;
    creationDate?: Date;
    modifiedDate?: Date;
    description?: string;
    informedUsers?: Array<User>;
    creationUser?: User;
    modifiedUser?: User;
    assignedToUser?: User;
    comment?: Array<Comment>;
    lph?: Task.LphEnum;
    projectId?: number;
    projectName?: string;
}
export namespace Task {
    export type StateEnum = 'OPEN' | 'PROCESS' | 'DONE' | 'VERIFIED';
    export const StateEnum = {
        OPEN: 'OPEN' as StateEnum,
        PROCESS: 'PROCESS' as StateEnum,
        DONE: 'DONE' as StateEnum,
        VERIFIED: 'VERIFIED' as StateEnum
    };
    export type PriorityEnum = 'HIGH' | 'NORMAL' | 'LOW';
    export const PriorityEnum = {
        HIGH: 'HIGH' as PriorityEnum,
        NORMAL: 'NORMAL' as PriorityEnum,
        LOW: 'LOW' as PriorityEnum
    };
    export type LphEnum = 'LPH1' | 'LPH2' | 'LPH3' | 'LPH4' | 'LPH5' | 'LPH6' | 'LPH7' | 'LPH8' | 'LPH9';
    export const LphEnum = {
        LPH1: 'LPH1' as LphEnum,
        LPH2: 'LPH2' as LphEnum,
        LPH3: 'LPH3' as LphEnum,
        LPH4: 'LPH4' as LphEnum,
        LPH5: 'LPH5' as LphEnum,
        LPH6: 'LPH6' as LphEnum,
        LPH7: 'LPH7' as LphEnum,
        LPH8: 'LPH8' as LphEnum,
        LPH9: 'LPH9' as LphEnum
    };
}